import { render, staticRenderFns } from "./CustomTextareaComponent.vue?vue&type=template&id=2032a5c1&scoped=true&"
import script from "./CustomTextareaComponent.vue?vue&type=script&lang=js&"
export * from "./CustomTextareaComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextareaComponent.vue?vue&type=style&index=0&id=2032a5c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032a5c1",
  null
  
)

export default component.exports